/* jshint scripturl:true */
'use strict'

module.exports = function(shariff) {
  var url = 'javascript:window.print();'

  return {
    name: 'print',
    faName: 'fa-print',
    popup: false,
    shareText: {
      'bg': '',
      'cs': 'tlačit',
      'da': '',
      'de': 'drucken',
      'en': 'print',
      'es': '',
      'fi': '',
      'fr': '',
      'hr': '',
      'hu': '',
      'it': '',
      'ja': '',
      'ko': '',
      'nl': '',
      'no': '',
      'pl': '',
      'pt': '',
      'ro': '',
      'ru': '',
      'sk': '',
      'sl': '',
      'sr': '',
      'sv': '',
      'tr': '',
      'zh': ''
    },
    title: {
      'bg': '',
      'cs': 'tlačit',
      'da': '',
      'de': 'drucken',
      'en': 'print',
      'es': '',
      'fi': '',
      'fr': '',
      'hr': '',
      'hu': '',
      'it': '',
      'ja': '',
      'ko': '',
      'nl': '',
      'no': '',
      'pl': '',
      'pt': '',
      'ro': '',
      'ru': '',
      'sk': '',
      'sl': '',
      'sr': '',
      'sv': '',
      'tr': '',
      'zh': ''
    },
    shareUrl: url
  }
}
